export default __webpack_public_path__ + "static/media/promo-produk.6a56febe.png";